(function () {
  var section = document.querySelector('.faq');
  if (!section) return;

  var list      = section.querySelector('.faq__list');
  var items     = list ? Array.prototype.slice.call(list.querySelectorAll('.faq__item')) : [];
  var tabs      = Array.prototype.slice.call(section.querySelectorAll('.faq__tab'));
  var moreWrap  = section.querySelector('.faq__more');
  var moreBtn   = section.querySelector('.faq__more-btn');
  var baseLimit = parseInt(section.getAttribute('data-limit'), 10) || 5;
  var hasTabs   = tabs.length > 0;
  var activeCat = hasTabs ? tabs[0].getAttribute('data-cat') : null;

  /* ---- Accordion toggle (height animation) ---- */
  items.forEach(function (item) {
    var btn   = item.querySelector('.faq__question');
    var panel = item.querySelector('.faq__answer');
    if (!btn || !panel) return;

    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';

      if (open) {
        panel.style.height = panel.scrollHeight + 'px';
        panel.offsetHeight;
        panel.style.height = '0';
        btn.setAttribute('aria-expanded', 'false');
      } else {
        panel.style.height = panel.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
        var onEnd = function () {
          panel.removeEventListener('transitionend', onEnd);
          if (btn.getAttribute('aria-expanded') === 'true') {
            panel.style.height = 'auto';
          }
        };
        panel.addEventListener('transitionend', onEnd);
      }
    });
  });

  /* ---- Close a single accordion ---- */
  function closeItem(item) {
    var btn   = item.querySelector('.faq__question');
    var panel = item.querySelector('.faq__answer');
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (panel) { panel.style.height = '0'; }
  }

  /* ---- Visibility ---- */
  function applyVisibility() {
    var catItems = [];

    items.forEach(function (item) {
      if (hasTabs && item.getAttribute('data-cat') !== activeCat) {
        item.style.display = 'none';
        return;
      }
      catItems.push(item);
    });

    catItems.forEach(function (item, idx) {
      item.style.display = idx < baseLimit ? '' : 'none';
    });

    if (moreWrap) {
      moreWrap.style.display = catItems.length > baseLimit ? '' : 'none';
    }
  }

  /* ---- Show more ---- */
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      var hidden = items.filter(function (item) {
        if (hasTabs && item.getAttribute('data-cat') !== activeCat) return false;
        return item.style.display === 'none';
      });

      hidden.slice(0, baseLimit).forEach(function (item) {
        item.style.display = '';
      });

      var remaining = hidden.length - Math.min(hidden.length, baseLimit);
      if (moreWrap) {
        moreWrap.style.display = remaining > 0 ? '' : 'none';
      }
    });
  }

  /* ---- Tab switching ---- */
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      tabs.forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');
      activeCat = tab.getAttribute('data-cat');

      items.forEach(function (item) { closeItem(item); });
      applyVisibility();
    });
  });

  applyVisibility();
})();
